// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * CSS Reset
 *
 * Based on :
 * https://www.joshwcomeau.com/css/custom-css-reset/
 * https://piccalil.li/blog/a-modern-css-reset/
 */

/* Use a more-intuitive box-sizing model */
*,
*::before,
*::after {
    box-sizing: border-box;
}

/* Remove default margin */
* {
    margin: 0;
}

/* Allow percentage-based heights in the application */
html,
body {
    height: 100%;
}

/* Typographic tweaks */
body {
    /* Add accessible line-height */
    line-height: 1.5;
    /* Improve text rendering */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

/* Improve media defaults */
img,
picture,
video,
canvas,
svg {
    display: block;
    max-width: 100%;
}

/* Remove built-in form typography styles */
input,
button,
textarea,
select {
    font: inherit;
}

/* Avoid text overflows */
p,
h1,
h2,
h3,
h4,
h5,
h6 {
    overflow-wrap: break-word;
}

/* Create a root stacking context */
#root {
    isolation: isolate;
}

/* Add smooth scrolling */
html:focus-within {
    scroll-behavior: smooth;
}

/* Remove all animations and transitions for people that prefer not to see them */
@media (prefers-reduced-motion: reduce) {
    html:focus-within {
        scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
        scroll-behavior: auto !important;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/reset.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF,0CAA0C;AAC1C;;;IAGI,sBAAsB;AAC1B;;AAEA,0BAA0B;AAC1B;IACI,SAAS;AACb;;AAEA,sDAAsD;AACtD;;IAEI,YAAY;AAChB;;AAEA,uBAAuB;AACvB;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,2BAA2B;IAC3B,mCAAmC;IACnC,kCAAkC;AACtC;;AAEA,2BAA2B;AAC3B;;;;;IAKI,cAAc;IACd,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;;;;IAII,aAAa;AACjB;;AAEA,yBAAyB;AACzB;;;;;;;IAOI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,uBAAuB;AAC3B;;AAEA,iFAAiF;AACjF;IACI;QACI,qBAAqB;IACzB;;IAEA;;;QAGI,qCAAqC;QACrC,uCAAuC;QACvC,sCAAsC;QACtC,gCAAgC;IACpC;AACJ","sourcesContent":["/**\n * CSS Reset\n *\n * Based on :\n * https://www.joshwcomeau.com/css/custom-css-reset/\n * https://piccalil.li/blog/a-modern-css-reset/\n */\n\n/* Use a more-intuitive box-sizing model */\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\n/* Remove default margin */\n* {\n    margin: 0;\n}\n\n/* Allow percentage-based heights in the application */\nhtml,\nbody {\n    height: 100%;\n}\n\n/* Typographic tweaks */\nbody {\n    /* Add accessible line-height */\n    line-height: 1.5;\n    /* Improve text rendering */\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n\n/* Improve media defaults */\nimg,\npicture,\nvideo,\ncanvas,\nsvg {\n    display: block;\n    max-width: 100%;\n}\n\n/* Remove built-in form typography styles */\ninput,\nbutton,\ntextarea,\nselect {\n    font: inherit;\n}\n\n/* Avoid text overflows */\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    overflow-wrap: break-word;\n}\n\n/* Create a root stacking context */\n#root {\n    isolation: isolate;\n}\n\n/* Add smooth scrolling */\nhtml:focus-within {\n    scroll-behavior: smooth;\n}\n\n/* Remove all animations and transitions for people that prefer not to see them */\n@media (prefers-reduced-motion: reduce) {\n    html:focus-within {\n        scroll-behavior: auto;\n    }\n\n    *,\n    *::before,\n    *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n        scroll-behavior: auto !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
